import { render, staticRenderFns } from "./WidgetSocialMedia.vue?vue&type=template&id=2589db24&scoped=true&lang=pug"
import script from "./WidgetSocialMedia.vue?vue&type=script&lang=ts"
export * from "./WidgetSocialMedia.vue?vue&type=script&lang=ts"
import style0 from "./WidgetSocialMedia.vue?vue&type=style&index=0&id=2589db24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589db24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VProgressLinear,VRow})
